// Un guide, choisi par son slug d'URL. Slug inconnu -> 404 (noindex), pas
// une page vide en 200 que Google garderait.
import { useParams } from 'react-router-dom'
import GuideShell from '../components/urself/GuideShell'
import NotFound from './NotFound'
import GUIDES from '../content/guides'

export default function Guide () {
  const { slug } = useParams()
  const guide = GUIDES.find(g => g.slug === slug)
  if (!guide) return <NotFound />
  return <GuideShell guide={guide} />
}
